import React from 'react';
import { Box, CircularProgress } from '@mui/material';
import DoneIcon from '@mui/icons-material/Done';
import { CssTextField } from 'components/select';
import { useRecoilState } from 'recoil';
import axios, { endPoints } from 'api/request';
import { useMutation } from 'react-query';
import { OrderPayload, validOnboardingForm, isValidationLoading } from 'pages/project-onboarding/store';
import ProjectOnboardingStyles from 'pages/project-onboarding/style';

export const ServiceAccount = () => {
    const [isTouched, setIsTouched] = React.useState(false);
    const [order, setOrder] = useRecoilState(OrderPayload);
    const [validForm, setValidForm] = useRecoilState(validOnboardingForm);
    const [, setIsLoading] = useRecoilState(isValidationLoading);
    const [helperText, setHelperText] = React.useState(false);
    const [errorText, setErrorText] = React.useState('');

    const validateServiceAccount = useMutation(() =>
        axios.get(`${endPoints.day2Operation.ProjectOnboarding?.Jwt?.validateServiceAccount}?serviceAccountId=${order?.serviceAccount}`)
    );

    const setServiceAccount = (serviceAccount = null) => {
        setOrder({
            ...order,
            serviceAccount,
        });
    };

    const hasWhiteSpace = (value) => {
        return value?.indexOf(' ') >= 0;
    };

    React.useEffect(() => {
        if (
            order?.serviceAccount &&
            order?.serviceAccount !== null &&
            order?.serviceAccount !== '' &&
            order?.serviceAccount !== undefined &&
            !/^[a-zA-Z0-9_-\s\\(\\)]{4,64}$/.test(order?.serviceAccount)
        ) {
            setHelperText(true);
            setErrorText('Service Account must have min 4 chars and can contain space, hyphen(-), underscore(_), slash(/) as special chars.');
            setValidForm({ ...validForm, isInvalidServiceAccount: true });
        } else {
            if (hasWhiteSpace(order?.serviceAccount)) {
                setHelperText(true);
                setErrorText('Space are not allowed in service account.');
                return setValidForm({ ...validForm, isInvalidServiceAccount: true });
            }
            setHelperText(false);
            setValidForm({ ...validForm, isInvalidServiceAccount: false });
        }
        return null;
    }, [order?.serviceAccount]);

    const validateInput = () => {
        if (
            (isTouched && order?.isTouched && !order?.serviceAccount) ||
            helperText ||
            (validForm?.isInvalidServiceAccount &&
                validForm?.isInvalidServiceAccount &&
                (validateServiceAccount?.data?.messages?.length > 0 || validateServiceAccount?.error?.length > 0))
        ) {
            return 'validate';
        }
        return '';
    };

    const getHelperText = () => {
        if (helperText) {
            return <span>{errorText}</span>;
        }
        if (
            validForm?.isInvalidServiceAccount &&
            validForm?.isInvalidServiceAccount &&
            (validateServiceAccount?.data?.messages?.length > 0 || validateServiceAccount?.error?.length > 0)
        ) {
            return <Box sx={ProjectOnboardingStyles.error}>{validateServiceAccount?.data?.messages?.[0] || validateServiceAccount?.error?.[0]}</Box>;
        }
        if (validateServiceAccount?.isLoading) {
            return 'Validating service account';
        }
        return '';
    };

    React.useEffect(() => {
        if (validateServiceAccount?.isSuccess && validateServiceAccount?.data?.data) {
            setValidForm({ ...validForm, isInvalidServiceAccount: false });
        }
        if (validateServiceAccount?.isSuccess && !validateServiceAccount?.data?.data) {
            setValidForm({ ...validForm, isInvalidServiceAccount: true });
        }
    }, [validateServiceAccount?.isSuccess]);

    React.useEffect(() => {
        if (order?.serviceAccount && order?.serviceAccount?.trim()?.length > 3) {
            validateServiceAccount.mutate();
        }
    }, [order?.serviceAccount]);

    const getServiceAccountValidation = () => {
        if (validateServiceAccount?.isLoading) {
            return <CircularProgress color="inherit" size={14} />;
        }
        if (order?.serviceAccount && !helperText && !validForm?.isInvalidServiceAccount && !validForm?.isInvalidServiceAccount) {
            return !validateServiceAccount?.isLoading && validateServiceAccount?.isSuccess ? <DoneIcon sx={{ color: '#00A86B' }} /> : null;
        }

        return false;
    };

    React.useEffect(() => {
        setIsLoading(validateServiceAccount?.isLoading);
    }, [validateServiceAccount?.isLoading]);

    React.useEffect(() => {
        if (!order?.serviceAccount && order?.isTouched) setIsTouched(true);
        else setIsTouched(false);
    }, [order?.serviceAccount, order?.isTouched]);

    return (
        <Box display="flex" alignItems="flex-start" flexDirection="column" data-testid="service-account-text">
            <CssTextField
                data-testid="app-name-text"
                size="small"
                sx={{
                    width: (theme) => theme.spacing('100%'),
                    '& .MuiFormHelperText-root': {
                        marginTop: (theme) => theme.spacing('-2'),
                    },
                }}
                disabled={!order?.adoPlatform || validForm?.isInvalidServiceAccount === true ? false : order?.isToolsProject}
                autoComplete="off"
                label="Service Account *"
                error={helperText}
                helperText={getHelperText()}
                value={order?.serviceAccount}
                onChange={(e) => setServiceAccount(e.target.value)}
                className={validateInput()}
                InputProps={{
                    endAdornment: <>{getServiceAccountValidation()}</>,
                }}
            />
        </Box>
    );
};

export default React.memo(ServiceAccount);
